import { FeatureCollection } from 'geojson';

/**
 * GeoJSON mockado com coordenadas aproximadas de bacias hidrográficas brasileiras
 */
export const mockGeoJsonBasins: FeatureCollection = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: {
        name: 'Bacia Amazonas',
        color: '#00c853',
        value: 85,
      },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          [-60, -3],
          [-60, -5],
          [-58, -5],
          [-58, -3],
          [-60, -3],
        ]],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bacia Paraná',
        color: '#2196f3',
        value: 62,
      },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          [-52, -22],
          [-52, -24],
          [-50, -24],
          [-50, -22],
          [-52, -22],
        ]],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bacia São Francisco',
        color: '#ff9800',
        value: 45,
      },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          [-40, -10],
          [-40, -14],
          [-38, -14],
          [-38, -10],
          [-40, -10],
        ]],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bacia Tocantins-Araguaia',
        color: '#4caf50',
        value: 72,
      },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          [-50, -5],
          [-50, -10],
          [-47, -10],
          [-47, -5],
          [-50, -5],
        ]],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bacia do Prata',
        color: '#2196f3',
        value: 58,
      },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          [-58, -25],
          [-58, -28],
          [-55, -28],
          [-55, -25],
          [-58, -25],
        ]],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bacia do Uruguai',
        color: '#03a9f4',
        value: 65,
      },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          [-54, -27],
          [-54, -30],
          [-51, -30],
          [-51, -27],
          [-54, -27],
        ]],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bacia Paraguai',
        color: '#00bcd4',
        value: 48,
      },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          [-57, -18],
          [-57, -22],
          [-54, -22],
          [-54, -18],
          [-57, -18],
        ]],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bacia Parnaíba',
        color: '#8bc34a',
        value: 78,
      },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          [-44, -5],
          [-44, -9],
          [-41, -9],
          [-41, -5],
          [-44, -5],
        ]],
      },
    },
  ],
};

/**
 * GeoJSON mockado com coordenadas aproximadas de regiões brasileiras
 */
export const mockGeoJsonRegions: FeatureCollection = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: {
        name: 'Região Norte',
        color: '#00c853',
        value: 82,
      },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          [-60, -2],
          [-60, -8],
          [-55, -8],
          [-55, -2],
          [-60, -2],
        ]],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Região Nordeste',
        color: '#ff9800',
        value: 55,
      },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          [-42, -3],
          [-42, -12],
          [-35, -12],
          [-35, -3],
          [-42, -3],
        ]],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Região Centro-Oeste',
        color: '#4caf50',
        value: 68,
      },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          [-55, -12],
          [-55, -20],
          [-48, -20],
          [-48, -12],
          [-55, -12],
        ]],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Região Sudeste',
        color: '#2196f3',
        value: 75,
      },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          [-48, -18],
          [-48, -24],
          [-42, -24],
          [-42, -18],
          [-48, -18],
        ]],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Região Sul',
        color: '#03a9f4',
        value: 70,
      },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          [-54, -24],
          [-54, -32],
          [-49, -32],
          [-49, -24],
          [-54, -24],
        ]],
      },
    },
  ],
};
